<div class="with-floating-button" actionsFlottantesCustom>
    <div class="content">
        <page-header *ngIf="showHeader$ | async" [title]="'admin.parametres.api.title' | translate" [listeItems]="listeTabItems" [selectedIndex]="selectedIndex" (onSelectedItemChange)="onSelectedItemChange($event)">
        </page-header>

        <router-outlet></router-outlet>
    </div>

    <floating-button [listeActions]="listeActions"></floating-button>
</div>